import { useLocation } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import axios from "axios";
import NavbarDumai from "../../Components/Navbar";
import { redirectToWA } from "../../../utils/waRedirect";

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
    snap: {
      pay: (
        token: string,
        options?: {
          onSuccess?: (result: any) => void;
          onPending?: (result: any) => void;
          onError?: (result: any) => void;
          onClose?: () => void;
        }
      ) => void;
    };
  }
}

const API = process.env.REACT_APP_API_BASE_URL;
const STORAGE = process.env.REACT_APP_STORAGE_URL;

export default function Checkout() {
  const { state } = useLocation();
  const { product, qty, size, color, price, ref } = state || {};
  const pixelCheckout = useRef(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const affiliateRef = ref || localStorage.getItem("affiliate_ref");
  const [currency, setCurrency] = useState<"IDR" | "USD" | "MYR">("IDR");
  const [convertedTotal, setConvertedTotal] = useState<number>(0);

  const total = price * qty;

  const handleOrder = async () => {
    // 🔥 TAMBAHAN (JANGAN HAPUS YANG LAMA)
    if (currency !== "IDR") {
      redirectToWA({
        name,
        email,
        phone,
        product: product.name,
        qty,
        total: convertedTotal,
        currency,
      });
      return; // ⛔ stop, tidak lanjut ke Midtrans
    }

    // 🔽 CODE LAMA KAMU (TIDAK DIUBAH SAMA SEKALI)
    try {
      setLoading(true);

      const formData = new FormData();
      formData.append("name", name);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("address", address);
      formData.append("product_id", product.id);
      formData.append("quantity", qty);
      if (affiliateRef) {
        formData.append("ref", affiliateRef);
      }

      const res = await axios.post(`${API}/api/checkout`, formData);

      console.log("Checkout response:", res.data);

      const snapToken = res.data.snap_token;

      if (!window.snap) {
        alert("Midtrans belum load");
        return;
      }

      window.snap.pay(snapToken, {
        onSuccess: function (result: any) {
          console.log("SUCCESS", result);

          if (window.fbq) {
            window.fbq("track", "Purchase", {
              content_name: product.name,
              content_ids: [product.id],
              content_type: "product",
              value: total,
              currency: "IDR",
            });
          }

          setShowSuccessPopup(true);
        },

        onPending: function (result: any) {
          console.log("PENDING", result);
          alert("Menunggu pembayaran");
        },

        onError: function (result: any) {
          console.log("ERROR", result);
          alert("Pembayaran gagal");
        },

        onClose: function () {
          console.log("Popup ditutup");
        },
      });

      setLoading(false);
    } catch (error) {
      console.log(error);
      alert("Checkout gagal");
      setLoading(false);
    }
  };

  const isFormValid = name.trim() !== "" && email.trim() !== "" && phone.trim() !== "" && address.trim() !== "";

  useEffect(() => {
    if (!product) return;
    if (pixelCheckout.current) return;

    if (window.fbq) {
      window.fbq("track", "InitiateCheckout", {
        content_name: product.name,
        content_ids: [product.id],
        content_type: "product",
        value: total,
        currency: "IDR",
        eventID: `checkout-${product.id}`,
      });

      console.log("InitiateCheckout fired");

      pixelCheckout.current = true;
    }
  }, [product]);

  const handleConfirmWA = () => {
    const message = `Assalamualaikum Hijafera,
  saya ${name} telah melakukan pembayaran.
  
  Produk : ${product.name}
  Qty : ${qty}
  Total : Rp ${total.toLocaleString()}
  
  Mohon dicek ya. Terima kasih 🙏`;

    const url = `https://wa.me/6281210681178?text=${encodeURIComponent(message)}`;

    window.open(url, "_blank");
  };

  useEffect(() => {
    const fetchRate = async () => {
      if (currency === "IDR") {
        setConvertedTotal(total);
        return;
      }

      try {
        const res = await axios.get("https://open.er-api.com/v6/latest/IDR");

        const rate = res.data.rates[currency];

        if (!rate) {
          console.log("Rate not found:", currency);
          return;
        }

        const converted = total * rate;

        setConvertedTotal(converted);
      } catch (err) {
        console.log("Currency error", err);
      }
    };

    fetchRate();
  }, [currency, total]);

  useEffect(() => {
    if (ref) {
      localStorage.setItem("affiliate_ref", ref);
    }
  }, [ref]);

  return (
    <section className="font-signika">
      <NavbarDumai />

      <section className="max-w-5xl mx-auto px-4 max-sm:pt-20 pt-32 pb-10 mb-8">
        <div className="grid md:grid-cols-2 gap-10">
          {/* PRODUCT */}
          <div className="border rounded-xl p-6">
            <img src={`${STORAGE}/products/${product.images[0].image}`} alt="" className="w-full rounded-lg mb-4" />

            <h2 className="font-semibold text-lg">{product.name}</h2>

            <p className="text-sm text-gray-500">Size : {size || "-"}</p>

            <p className="text-sm text-gray-500">Color : {color || "-"}</p>

            <p className="text-sm text-gray-500">Qty : {qty}</p>

            <div className="mt-4 font-bold text-primary">{currency === "IDR" ? `Rp ${total.toLocaleString()}` : `${currency} ${convertedTotal.toFixed(2)}`}</div>
          </div>

          {/* FORM */}
          <div className="space-y-4">
            <input type="text" placeholder="Nama" value={name} onChange={(e) => setName(e.target.value)} className="w-full border p-3 rounded-lg" />

            <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full border p-3 rounded-lg" />

            <input type="text" placeholder="No HP" value={phone} onChange={(e) => setPhone(e.target.value)} className="w-full border p-3 rounded-lg" />

            <textarea placeholder="Alamat Pengiriman" value={address} onChange={(e) => setAddress(e.target.value)} className="w-full border p-3 rounded-lg" />

            <select value={currency} onChange={(e) => setCurrency(e.target.value as any)} className="w-full border p-3 rounded-lg">
              <option value="IDR">IDR </option>
              <option value="USD">USD </option>
              <option value="MYR">MYR / Ringgit </option>
            </select>

            <button
              onClick={handleOrder}
              disabled={!isFormValid || loading}
              className={`w-full py-3 rounded-lg font-semibold transition
              ${isFormValid && !loading ? "bg-primary text-white hover:bg-purple-600" : "bg-gray-300 text-gray-500 cursor-not-allowed"}`}>
              {loading ? "Loading..." : "ORDER"}
            </button>
          </div>
        </div>
      </section>

      {showSuccessPopup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-8 max-w-md w-full text-center shadow-xl">
            <div className="text-5xl mb-4">🎉</div>

            <h2 className="text-xl font-bold mb-2">Pembayaran Berhasil</h2>

            <p className="text-gray-500 mb-6">Terima kasih sudah melakukan pembayaran. Silakan konfirmasi pembayaran melalui WhatsApp.</p>

            <div className="space-y-3">
              <button onClick={handleConfirmWA} className="w-full bg-green-500 text-white py-3 rounded-lg hover:bg-green-600 font-semibold">
                Konfirmasi Pembayaran
              </button>

              <button onClick={() => setShowSuccessPopup(false)} className="w-full border py-3 rounded-lg">
                Tutup
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
